import { IconLock } from '../components/ui/icons';
import React from 'react';
import { Link } from 'react-router-dom';
import EnhancedPrivateRoute from './EnhancedPrivateRoute';
import { useAuth } from './EnhancedSupabaseAuthContext';
import { isAdminUser } from './roles';
import AdminMfaGate from './AdminMfaGate';

const AdminOnly = ({ children }) => {
  const { user } = useAuth();

  if (!isAdminUser(user)) {
    return (
      <div className="max-w-4xl mx-auto p-6 text-center min-h-[50vh] flex flex-col items-center justify-center">
        <h1 className="text-2xl font-bold mb-4"><IconLock className="inline-block h-[1em] w-[1em] align-[-0.125em]" aria-hidden="true" /> Accès réservé aux administrateurs</h1>
        <p className="text-gray-600 mb-4">Votre compte n'a pas les droits nécessaires pour ouvrir cette page.</p>
        <Link to="/dashboard" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
          Retour au tableau de bord
        </Link>
      </div>
    );
  }

  // Administrateur : code de double vérification exigé avant d'ouvrir l'administration
  return <AdminMfaGate>{children}</AdminMfaGate>;
};

/**
 * Route réservée aux administrateurs (outils de diagnostic, tests, administration).
 * Non connecté → page de connexion ; connecté sans droits → message d'accès refusé ;
 * administrateur → double vérification (AdminMfaGate), puis la page.
 */
const AdminRoute = ({ children }) => (
  <EnhancedPrivateRoute>
    <AdminOnly>{children}</AdminOnly>
  </EnhancedPrivateRoute>
);

export default AdminRoute;
